import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { jwtDecode } from 'jwt-decode';
import { filter } from 'rxjs';
import { IdentityStorage } from 'storage-service-lib';

interface BullhornJwt {
  name: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterModule, CommonModule],
})
export class AppComponent implements OnInit {
  private identityStorage = inject(IdentityStorage);
  private router = inject(Router);

  displayName = '';
  tenant = '';
  isChatRoute = false;

  ngOnInit(): void {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e) => {
        const url = (e as NavigationEnd).urlAfterRedirects;
        this.isChatRoute =
          url.startsWith('/chat') ||
          url.startsWith('/bw-mcp-chat') ||
          url.startsWith('/bullhorn-login-assistant') ||
          url.startsWith('/bullhorn-session-identity') ||
          url.startsWith('/candidate-rating-agent') ||
          url.startsWith('/interview-prep-brief') ||
          url.startsWith('/cv-formatter') ||
          url.startsWith('/client-reengagement');
        this.readIdentity();
      });
  }

  private readIdentity(): void {
    const identity = this.identityStorage.get();
    if (!identity?.token) return;
    const decoded = jwtDecode<BullhornJwt>(identity.token);
    this.displayName = decoded.name ?? '';
    this.tenant = identity.tenant ?? '';
  }
}
